const STORAGE_KEY = "restaurant-storefront-order-chime";

let audioContext;
let lastPlayedAt = 0;
const announcedOrders = new Set();

export const isStorefrontChimeEnabled = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) !== "off";
    } catch {
        return true;
    }
};

export const setStorefrontChimeEnabled = (enabled) => {
    try {
        localStorage.setItem(STORAGE_KEY, enabled ? "on" : "off");
    } catch {
        // Keep the current browser session usable when storage is unavailable.
    }
};

const scheduleTone = (context, frequency, start, duration, peakVolume) => {
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(frequency, start);
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(peakVolume, start + 0.06);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start(start);
    oscillator.stop(start + duration + 0.02);
};

export const playSmoothStorefrontChime = async ({ force = false } = {}) => {
    if (!force && !isStorefrontChimeEnabled()) return false;
    if (!force && Date.now() - lastPlayedAt < 900) return false;

    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return false;
        audioContext = audioContext || new AudioContext();
        if (audioContext.state === "suspended") await audioContext.resume();
        if (audioContext.state !== "running") return false;

        lastPlayedAt = Date.now();
        const start = audioContext.currentTime + 0.02;
        // A quiet ascending major chord with long envelopes is noticeable without
        // the sharp, repetitive character of the existing late-order alarm.
        scheduleTone(audioContext, 523.25, start, 0.72, 0.055);
        scheduleTone(audioContext, 659.25, start + 0.11, 0.76, 0.045);
        scheduleTone(audioContext, 783.99, start + 0.24, 0.82, 0.035);
        return true;
    } catch {
        // Autoplay policies can block audio until the user interacts with the page.
        return false;
    }
};

export const announceStorefrontOrder = (orderName) => {
    const name = String(orderName || "").trim();
    if (!name || announcedOrders.has(name)) return Promise.resolve(false);
    if (announcedOrders.size >= 500) announcedOrders.clear();
    announcedOrders.add(name);
    return playSmoothStorefrontChime();
};
